import React, { useState, useCallback, memo } from "react";
import "./ProductTable.scss";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Link } from "react-router-dom";
import DeleteProduct from "../DelteProduct/DeleteProduct";
import { BASE_URL_IMAGE_Product } from "../../../../Consts";

/* ─── All styles defined ONCE outside the component — never recreated ─── */
const DESCRIPTION_STYLES = {
    maxWidth: 260,
    maxHeight: 120,
    overflowY: "auto",
    fontSize: 13,
    lineHeight: 1.5,
};

const BTN_BASE = {
    width: 108,
    height: 37,
    boxShadow: "0px 4px 4px rgba(0,0,0,0.25)",
    borderRadius: 6,
    outline: "none",
    border: "none",
    color: "white",
    cursor: "pointer",
    fontWeight: 400,
    fontSize: 16,
};
const BTN_UPDATE = { ...BTN_BASE, background: "#4FCF3B" };
const BTN_DELETE = { ...BTN_BASE, background: "#E30000" };

const TABLE_CSS = `
  .tableContainer ul, .tableContainer ol { margin: 4px 0; padding-left: 18px; }
  .tableContainer li { margin-bottom: 2px; }
  .tableContainer p  { margin: 2px 0; }
  .tableContainer b, .tableContainer strong { font-weight: 600; }
`;

/* ─── Single memoized row — only re-renders if its own `row` data changes ─── */
const ProductRow = memo(({ row, index, onDelete }) => {
    const imgSrc = row?.images?.[0]?.image
        ? `${BASE_URL_IMAGE_Product}/${row.images[0].image}`
        : "https://via.placeholder.com/150";

    return (
        <TableRow>
            <TableCell component="th" scope="row">{index}</TableCell>

            <TableCell>{row?.name}</TableCell>

            <TableCell>{row?.categories?.[0]?.name}</TableCell>

            <TableCell>
                {/* loading="lazy" defers off-screen images — big win for lists */}
                <img
                    src={imgSrc}
                    alt="product"
                    loading="lazy"
                    width={96}
                    height={90}
                    style={{ objectFit: "cover", display: "block" }}
                />
            </TableCell>

            <TableCell>
                <div
                    dangerouslySetInnerHTML={{ __html: row?.description }}
                    style={DESCRIPTION_STYLES}
                />
            </TableCell>

            <TableCell>{row?.location}</TableCell>

            <TableCell>{row?.lang?.name}</TableCell>

            <TableCell>
                <Link to={`/updateProduct/${row.id}`}>
                    <button style={BTN_UPDATE}>Update</button>
                </Link>
            </TableCell>

            <TableCell>
                <button style={BTN_DELETE} onClick={() => onDelete(row.id)}>
                    Delete
                </button>
            </TableCell>
        </TableRow>
    );
});

/* ─── Parent table ─── */
const ProductTable = ({ data }) => {
    const [selectedRow, setSelectedRow] = useState(null);
    const [showWarning, setShowWarning] = useState(false);

    /* Stable callback reference — rows won't re-render when warning opens/closes */
    const handleDelete = useCallback((id) => {
        setSelectedRow(id);
        setShowWarning((prev) => !prev);
    }, []);

    return (
        <div className="tableContainer">
            {/* Single style injection — not re-created on every render */}
            <style>{TABLE_CSS}</style>

            <TableContainer>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Product Name</TableCell>
                            <TableCell>Product Category</TableCell>
                            <TableCell>Image</TableCell>
                            <TableCell>Description</TableCell>
                            <TableCell>Country</TableCell>
                            <TableCell>Lan</TableCell>
                            <TableCell />
                            <TableCell />
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {data?.map((row, i) => (
                            <ProductRow
                                key={row.id}        /* stable key by id — not array index */
                                row={row}
                                index={i + 1}
                                onDelete={handleDelete}
                            />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {showWarning && (
                <DeleteProduct
                    id={selectedRow}
                    setShowWarning={setShowWarning}
                    showWarning={showWarning}
                />
            )}
        </div>
    );
};

export default ProductTable;